import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { QuoteProductPolicyListView } from 'src/app/bookings/quote-product-policies/list/quote-product-policy-list.view';
import { QuotePolicyListDataService } from 'src/app/bookings/quote-policies/list/quote-policy-list.data';

@observer
export class QuoteProductPolicyListController extends React.Component<ControllerProps<any>, {}> {
	@observable
	dataService: QuotePolicyListDataService;

	@resolve
	toast: ToastNotifications;

	constructor(props: Readonly<ControllerProps<any>>) {
		super(props);
	}

	private async loadData(): Promise<void> {
		this.dataService = QuotePolicyListDataService.make();

		this.dataService.pageSize = 20;
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('type', 'eq', 1);
		this.dataService.addFilter('isDeleted', 'eq', false);

		await this.dataService.load((query) => query);
	}


	handleItemDoubleClicked = (item?: QuotePolicySummary): void => {
		this.props.history.push(`/bookings/quote-product-policies/${item == null ? 'new' : item.id}`);
	}

	componentDidMount() {
		this.props.setBusy(true);
		this.loadData()
			.then(() => {
				this.props.setBusy(false);
			})
			.catch((error) => {
				this.props.setBusy(false);
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	}

	render() {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		return (
			<QuoteProductPolicyListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				onItemDoubleClicked={this.handleItemDoubleClicked}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-policies/list/quote-product-policy-list.controller.tsx